import { buildQuery, containsQuery, OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, downloadFileHandler, request } from "services/request";

const resource = "api/legalPersons";
const defQuery = { orderBy: ["id desc"] };

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, ...defQuery });
    return request(
        `${resource}/getlist?withDeleted=true&${query.substr(1)}`,
        { method: "GET" },
        { countInHeaders: true },
    );
};

const getListExcel = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter }).substr(1);
    return request(
        `${resource}/getListExcel?withDeleted=true&${query}`,
        { method: "GET" },
        { withoutMiddleware: true },
    ).then((res) => downloadFileHandler(res, "Организации.xlsx"));
};

const list = (params: {}) => request(`${resource}/getlist${containsQuery(params)}`, { method: "GET" });

export const organizationLegalPersonId = -1;
const organizationOption = { id: organizationLegalPersonId, name: "Организация" };

/** Keep the organization option local while delegating real IDs and searches to the normal lookup. */
export const listWithOrganization = async (params: OdataFilters) => {
    const idFilter = params.filters?.find(({ dataIndex }) => dataIndex === "id");
    let filters = params.filters;
    if (idFilter) {
        const ids = (Array.isArray(idFilter.value) ? idFilter.value : [idFilter.value]).filter(
            (id) => id !== organizationLegalPersonId,
        );
        if (!ids.length) {
            return [organizationOption];
        }
        filters = params.filters?.map((filter) => (filter === idFilter ? { ...filter, value: ids } : filter));
    }
    const legalPersons = await list({ ...params, filters });
    return [organizationOption, ...(Array.isArray(legalPersons) ? legalPersons : [])];
};

const getItem = (id: string) => request(`${resource}/get/${id}`, { method: "GET" });

const editLogo = (params: {}) => alertRequest(`${resource}/editLogo`, params);

const clearLogo = (params: {}) => alertRequest(`${resource}/clearLogo`, body(params));

const uploadSigningFiles = (params: {}) => alertRequest(`${resource}/uploadSigningFiles`, params);

const uploadAccountantSigningFiles = (params: {}) => alertRequest(`${resource}/uploadAccountantSigningFiles`, params);

const editAccountant = (params: {}) => alertRequest(`${resource}/applyAccountant`, body(params));

const count = () => {
    const query = queryCollection({}, { count: true });
    return request(`${resource}/getlist${query}`, { method: "GET" });
};

const apply = (params: {}) => alertRequest(`${resource}/apply`, body(params));

const setMain = (params: {}) => alertRequest(`${resource}/setMain`, body(params));

const unsetMain = (params: {}) => alertRequest(`${resource}/unsetMain`, body(params));

const getMain = () => {
    const query = buildQuery({ filter: { flags: { has: "Main" } } });
    return request(`${resource}/getlist${query}`, { method: "GET" }).then((data) =>
        data && data.length ? data[0] : {},
    );
};

const deleteItem = (params: {}) => alertRequest(`${resource}/delete`, body(params));

const restore = (params: {}) => alertRequest(`${resource}/restore`, body(params));

const getBankAccounts = (legalPersonId: string | number, params: OdataFilters = {}) =>
    request(`${resource}/getBankAccounts/${legalPersonId}${containsQuery(params)}`, { method: "GET" });

const applyBankAccount = (params: {}) => alertRequest(`${resource}/applyBankAccount`, body(params));

const deleteBankAccount = (params: {}) => alertRequest(`${resource}/deleteBankAccount`, body(params));

export {
    index,
    list,
    count,
    apply,
    deleteItem,
    setMain,
    unsetMain,
    getMain,
    getListExcel,
    getItem,
    restore,
    editLogo,
    clearLogo,
    getBankAccounts,
    applyBankAccount,
    deleteBankAccount,
    uploadSigningFiles,
    uploadAccountantSigningFiles,
    editAccountant,
};
